import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery, MenuItem, ListItemIcon, Collapse, useTheme, Typography, Tooltip } from '@material-ui/core';
import { MenuItemLink, getResources, DashboardMenuItem } from 'react-admin';
import { ExpandMore } from '@material-ui/icons';

import { FaCog, FaUsers, FaShoppingCart, FaBroadcastTower, FaTractor, FaSeedling, FaPiggyBank, FaHandshake, FaFlag, FaLandmark, FaGraduationCap, FaRocket, FaLeaf, FaCity, FaBookOpen } from 'react-icons/fa';
import { GiPlantRoots, GiFarmTractor, GiFactory } from 'react-icons/gi';
import { SiGooglehome } from 'react-icons/si';
import { MdManageAccounts, MdOutlineAnalytics } from 'react-icons/md';

const SubMenu = (props) => {
    const theme = useTheme();
    const [show, setShow] = useState(false);

    return <React.Fragment>
        <MenuItem dense={false} button onClick={() => { setShow(!show) }}>
            {
                !props.open ?
                    <Tooltip title={props.title} placement="right">
                        <ListItemIcon style={{ minWidth: 40 }}>
                            {show ? <ExpandMore /> : props.leftIcon}
                        </ListItemIcon>
                    </Tooltip>
                    :
                    <ListItemIcon style={{ minWidth: 40 }}>
                        {show ? <ExpandMore /> : props.leftIcon}
                    </ListItemIcon>
            }
            <Typography color="textSecondary">
                {props.title}
            </Typography>
        </MenuItem>
        <Collapse in={show} timeout="auto" unmountOnExit style={{ paddingLeft: props.open ? theme.spacing(4) : 0 }}>
            {props.children}
        </Collapse>
    </React.Fragment>
}

const Menu = ({ onMenuClick, logout }) => {
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const open = useSelector(state => state.admin.ui.sidebarOpen);
    const resources = useSelector(getResources);
    const props = { onMenuClick, logout, open };
    //console.log('resources', resources)

    const groups = [
        { name: '设置', icon: <FaCog color="#6B7280" size={20} /> },
        { name: '成员', icon: <FaUsers color="#3B82F6" size={20} /> },

        // { name: '商品', icon: <AssistantIcon /> },
        // { name: '订单', icon: <ReorderIcon /> },
        { name: '商城', icon: <FaShoppingCart color="#F59E0B" size={20} /> },

        { name: '物联网设备', icon: <FaBroadcastTower color="#10B981" size={20} /> },

        { name: '农业主体', icon: <FaTractor color="#8B5CF6" size={20} /> },

        { name: '智慧种植', icon: <FaSeedling color="#22C55E" size={20} /> },
        { name: '智慧畜牧', icon: <FaPiggyBank color="#EC4899" size={20} /> },

        { name: '农业服务', icon: <FaHandshake color="#06B6D4" size={20} /> },

        { name: '数字治理', icon: <MdOutlineAnalytics color="#6366F1" size={20} /> },
        { name: '数字普惠', icon: <SiGooglehome color="#14B8A6" size={20} /> },
        { name: '美丽乡村', icon: <FaCity color="#84CC16" size={20} /> },
        { name: '人才建设', icon: <MdManageAccounts color="#A855F7" size={20} /> },

        { name: '党建管理', icon: <FaFlag color="#EF4444" size={20} /> },
        { name: '政务服务', icon: <FaLandmark color="#3B82F6" size={20} /> },
        { name: '技能培训', icon: <FaGraduationCap color="#F59E0B" size={20} /> },
        { name: '返乡创业', icon: <FaRocket color="#EF4444" size={20} /> },

        { name: '环境治理', icon: <FaLeaf color="#22C55E" size={20} /> },

        { name: '农技推广', icon: <FaBookOpen color="#22C55E" size={20} /> },

    ]

    return (
        <div>
            <DashboardMenuItem onClick={onMenuClick} sidebarIsOpen={open} />
            {groups.map((group, index) => {
                let resArr = resources.filter(t => t.options.group == group.name);
                if (resArr.length > 0)
                    return (
                        <SubMenu key={index} {...props} title={group.name} leftIcon={group.icon}>
                            {resArr.map(resource => {
                                // console.log('resource', resource)
                                return (
                                    <MenuItemLink
                                        key={resource.name}
                                        to={(resource.options && resource.options.customRoutes) ?
                                            `/${resource.options.customRoutes}` : `/${resource.name}`}
                                        primaryText={resource.options && resource.options.label || resource.name}
                                        leftIcon={resource.icon}
                                        onClick={onMenuClick}
                                        sidebarIsOpen={open}
                                    />
                                )
                            })}
                        </SubMenu>)
                else
                    return null;
            })}

            {/* <MenuItemLink
                to="/custom-route"
                primaryText="Miscellaneous"
                leftIcon={<LabelIcon />}
                onClick={onMenuClick}
                sidebarIsOpen={open}
            /> */}
            {isXSmall && logout}
        </div>
    );
};

export default Menu;